export const NO_PROBE_VALUE = 0;
export const REBOUND_VALUE = 1;
export const UCI_VALUE = 2;
export const UNKNOWN1_VALUE = 3;
export const UNKNOWN2_VALUE = 4;
export const REBOUND_OLD_VALUE = 5;
export const UCI_NEW_VALUE = 130;